import React, { useEffect, useContext } from 'react';

const createResizeObserver = () => {
  const ResizeObserverContext = React.createContext(null);
  const subscribers = new Map();

  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      if (subscribers.has(entry.target)) {
        const existingSet = subscribers.get(entry.target);
        existingSet.forEach(callback => callback(entry));
      }
    }
  })

  const subscribe = (observable, callback, observer = '') => {
    let existingSet;
    if (subscribers.get(observable)) {
      existingSet = subscribers.get(observable);
    } else {
      resizeObserver.observe(observable);
      existingSet = new Set();
    }
    subscribers.set(observable, existingSet.add(callback));
    return () => {
      existingSet.delete(callback);
      if (existingSet.size === 0) {
        subscribers.delete(observable);
        resizeObserver.unobserve(observable);
      } else {
        subscribers.set(observable, existingSet);
      }
    };
  }

  function Provider({ children }) {
    return (
      <ResizeObserverContext.Provider value={subscribe}>
        {children}
      </ResizeObserverContext.Provider>
    )
  };

  function useStore(observable, callback, observer = '') {
    const subscribe = useContext(ResizeObserverContext);

    useEffect(() => {
      if (document.getElementById(observable)) {
        return subscribe(document.getElementById(observable), callback, observer);
      } else {
        console.log("Not subscribing to resize observer!! ", observable);
      }
    }, [observable]);

    return [];
  }

  return {
    Provider,
    useStore
  };
};

export default createResizeObserver;